// External links
export const CROWN_COPYRIGHT_URL = 'https://www.nationalarchives.gov.uk/information-management/re-using-public-sector-information/uk-government-licensing-framework/crown-copyright/';
export const FEEDBACK_URL = 'https://www.homeofficesurveys.homeoffice.gov.uk/s/6MBWPJ/';
export const GOV_URL = 'https://www.gov.uk/';

// External guidance links (on help locations)
export const PASSWORD_GUIDENCE_URL = 'https://www.ncsc.gov.uk/collection/top-tips-for-staying-secure-online/three-random-words#:~:text=Why%20does%20the%20NCSC%20recommend,enough%20for%20you%20to%20remember';
export const EXAM_IDENTITY_DOCS_URL = 'https://www.gov.uk/government/publications/recognising-fraudulent-identity-documents';

// Regulatory pages
export const ACCESSIBILITY_URL = '/accessibility-statement';
export const COOKIE_URL = '/cookies';
export const INTERSTITIAL_URL = '/information';
export const LANDING_URL = '/';
export const PRIVACY_URL = '/privacy-notice';
export const CONTACT_US_URL = '/contact-us';
export const DELETE_ACCOUNT_URL = '/account/delete';
export const DELETE_ACCOUNT_SUCCESS_URL = '/account/delete-confirmation';
export const MESSAGE_URL = '/message';

// Voyage pages
export const URL_DECLARATIONID_IDENTIFIER = 'report';
export const PASSENGER_LIST_TYPE_BOARDED = 'boarded';
export const PASSENGER_LIST_TYPE_CHECKS = 'checks';
export const PASSENGER_LIST_TYPES = [PASSENGER_LIST_TYPE_BOARDED, PASSENGER_LIST_TYPE_CHECKS];

export const VOYAGE_CHANGE_DETAILS = '/report-voyage/confirm-change-details';
export const VOYAGE_CHECK_YOUR_ANSWERS = '/report-voyage/check-your-answers';
export const VOYAGE_CREW_HOLDING_URL = '/report-voyage/crew-details-processing';
export const VOYAGE_CREW_UPLOAD_URL = '/report-voyage/upload-crew-details';
export const VOYAGE_DELETE_DRAFT_CHECK_URL = '/report-voyage/confirm-delete-draft';
export const VOYAGE_GENERAL_DECLARATION_UPLOAD_URL = '/report-voyage/upload-general-declaration';
export const VOYAGE_PASSENGERS_URL = '/report-voyage/passenger-details';
export const VOYAGE_PASSENGER_UPLOAD_URL = '/report-voyage/upload-passenger-details';
export const VOYAGE_PASSENGER_LIST_DOWNLOAD_ERROR_URL = '/report-voyage/passenger-list-download-error';
export const VOYAGE_UPT_RESULTS_URL = '/report-voyage/status-checker';
export const VOYAGE_UPT_DASHBOARD_URL = '/report-voyage/upt-summary';
export const VOYAGE_UPT_0T_RESULTS_URL = '/report-voyage/0T-results';
export const VOYAGE_UPT_SEARCH_RESULTS_URL = '/report-voyage/upt-search-results';
export const VOYAGE_UPT_PASSENGER_LIST_URL = '/report-voyage/passenger-list';
export const VOYAGE_UPT_PASSENGER_LIST_BOARDED_URL = `${VOYAGE_UPT_PASSENGER_LIST_URL}/${PASSENGER_LIST_TYPE_BOARDED}`; // /report-voyage/passenger-list/boarded
export const VOYAGE_UPT_PASSENGER_LIST_CHECKS_URL = `${VOYAGE_UPT_PASSENGER_LIST_URL}/${PASSENGER_LIST_TYPE_CHECKS}`; // /report-voyage/passenger-list/checks
export const VOYAGE_SUPPORTING_DOCS_UPLOAD_URL = '/report-voyage/upload-supporting-documents';
export const VOYAGE_TASK_LIST_URL = '/report-voyage';
export const YOUR_VOYAGES_PAGE_NAME = 'Your voyages';
export const YOUR_VOYAGES_URL = '/your-voyages';

// Register/Sign in pages
export const REGISTER_ACCOUNT_URL = '/create-account/email-address';
export const REGISTER_CONFIRMATION_URL = '/create-account/account-created';
export const REGISTER_EMAIL_URL = '/create-account/email-address';
export const REGISTER_EMAIL_CHECK_URL = '/create-account/check-your-email';
export const REGISTER_EMAIL_RESEND_URL = '/create-account/request-new-verification-link';
export const REGISTER_DETAILS_URL = '/create-account/your-details';
export const REGISTER_PASSWORD_URL = '/create-account/your-password';
export const ERROR_ACCOUNT_ALREADY_ACTIVE_URL = '/create-account/account-already-exists';
export const REGISTER_EMAIL_VERIFIED_URL = '/activate-account';
export const RESEND_EMAIL_USER_NOT_VERIFIED = '/resend-verfication-email';
export const REQUEST_PASSWORD_RESET_URL = '/forgotten-password';
export const REQUEST_PASSWORD_RESET_CONFIRMATION_URL = '/forgotten-password/check-your-email';
export const REQUEST_PASSWORD_RESET_RESEND_URL = '/forgotten-password/request-new-link';
export const RESET_YOUR_PASSWORD = '/new-password'; // this is a logged out version
export const SIGN_IN_URL = '/sign-in';
export const LOGGED_IN_LANDING = YOUR_VOYAGES_URL;

// Other pages
export const FILE_UPLOAD_FIELD_ERRORS_URL = '/field-errors';
export const GENERIC_CONFIRMATION_URL = '/confirmation';
export const TEMPLATE_PAGE_NAME = 'Voyage report forms';
export const TEMPLATE_PAGE_URL = '/voyage-report-forms';
export const LOGGED_IN_HELP = '/help-page';
export const HELP_URL = '/help';
export const HELP_PAGE_NAME = 'Help';

// User details pages
export const YOUR_DETAILS_PAGE_NAME = 'Your details';
export const YOUR_DETAILS_PAGE_URL = '/your-details';
export const CHANGE_YOUR_DETAILS_PAGE_NAME = 'Change your details';
export const CHANGE_YOUR_DETAILS_PAGE_URL = '/change-your-details';
export const CHANGE_YOUR_PASSWORD_PAGE_NAME = 'Change your password';
export const CHANGE_YOUR_PASSWORD_PAGE_URL = '/change-your-password'; // this is a logged in version

// Error/message pages

// Top level pages - we use this to know to clear form session data
export const TOP_LEVEL_PAGES = [
  ACCESSIBILITY_URL,
  COOKIE_URL,
  CONTACT_US_URL,
  LANDING_URL,
  LOGGED_IN_HELP,
  PRIVACY_URL,
  TEMPLATE_PAGE_URL,
  YOUR_DETAILS_PAGE_URL,
  YOUR_VOYAGES_URL,
  VOYAGE_TASK_LIST_URL,
];

// Pages without back links
export const NO_BACK_LINKS = [
  ...TOP_LEVEL_PAGES,
  GENERIC_CONFIRMATION_URL,
  INTERSTITIAL_URL,
  MESSAGE_URL,
  REGISTER_CONFIRMATION_URL,
  REGISTER_DETAILS_URL,
  REGISTER_EMAIL_CHECK_URL,
  REGISTER_EMAIL_VERIFIED_URL,
  REQUEST_PASSWORD_RESET_CONFIRMATION_URL,
  SIGN_IN_URL,
  VOYAGE_CHECK_YOUR_ANSWERS,
  VOYAGE_CREW_HOLDING_URL,
  VOYAGE_TASK_LIST_URL,
  VOYAGE_UPT_RESULTS_URL,
  VOYAGE_UPT_0T_RESULTS_URL,
  VOYAGE_UPT_SEARCH_RESULTS_URL,
  VOYAGE_PASSENGER_LIST_DOWNLOAD_ERROR_URL,
  VOYAGE_UPT_PASSENGER_LIST_BOARDED_URL,
  VOYAGE_UPT_PASSENGER_LIST_CHECKS_URL,
  VOYAGE_UPT_DASHBOARD_URL,
];

export const CHECK_PERMISSION_GUIDANCE_URL = 'https://www.gov.uk/government/publications/document-checks-and-charges-for-carriers';
export const AUTHORITY_TO_CARRY_URL = 'https://www.gov.uk/government/publications/authority-to-carry-scheme-2023';
export const TRAVEL_DOCUMENT_URL = 'https://assets.publishing.service.gov.uk/media/6876255188da2e5804bb6a26/2025_Guidance_on_examining_identity_documents_.pdf';
export const PASSPORT_TRAVEL_DOCUMENT_URL = 'https://assets.publishing.service.gov.uk/government/uploads/system/uploads/attachment_data/file/1134497/Guidance_on_examining_identity_documents.pdf';
export const UK_VISA_REQUIREMENT_INTERNATIONAL_URL = 'https://www.gov.uk/government/publications/uk-visa-requirements-list-for-carriers/uk-visa-requirements-for-international-carriers';
export const DIGITAL_PERMISSION_URL = '';
export const PERMISSION_UK_VISA_REQUIREMENT_URL = 'https://www.gov.uk/government/publications/uk-visa-requirements-list-for-carriers';
export const CHECK_NATIONALITY_URL = 'https://www.gov.uk/guidance/check-when-you-can-get-an-electronic-travel-authorisation-eta';
export const SHARE_CODE_URL = 'https://www.gov.uk/check-immigration-status';
export const ETA_STATUS_URL = 'https://www.gov.uk/check-eta';
export const CHECK_ETA_URL = 'https://www.gov.uk/check-uk-visa';
